import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';

const WrapperTextField = styled(TextField)`
  /* keep your existing styles (trimmed here for brevity) */
  width: 100%;
  margin-top: ${(props) =>
    props.marginLabelTop ? `${props.marginLabelTop}px` : '20px !important'};

  .MuiInput-root {
    border: 1px solid ${(props) => (props.errorText ? '#EE3232' : '#DDDDDD')};
    height: ${(props) =>
      props.height ? props.height + 'px' : '50px !important'};
    padding: 15px;
    font-family: Akkurat;
    font-size: 16px;
  }

  .MuiOutlinedInput-root {
    & fieldset {
      border-color: #dddddd; /* default border */
    }
    &:hover fieldset {
      border-color: #1e1e1e; /* no hover color change */
    }
    &.Mui-focused fieldset {
      border-color: #1e1e1e; /* no focus color change */
    }
  }

  .MuiInputLabel-root.Mui-focused {
    color: #292d32 !important;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  &:hover {
    background-color: #fff2f8 !important;
    color: #911e59 !important;
  }
`;

const WrapperErrorDiv = styled.div`
  font-size: 16px;
  color: #ee3232;
  line-height: 24px;
  font-family: Akkurat;
  margin-top: 5px;
  position: absolute;
  bottom: -30px;
`;

/* helper to get the display label from an option (handles string or object) */
const getLabel = (opt) => {
  if (!opt && opt !== 0) return '';
  if (typeof opt === 'string') return opt;
  return (
    opt?.name?.name_en ||
    opt?.name ||
    opt?.searched_business_name_en ||
    opt?.label ||
    opt?.specialist_name_en ||
    ''
  );
};

function SelectSearchInput({
  data = [],
  getValue,
  onInputChange: externalOnInputChange,
  placeholder = 'Select',
  freeSolo = true, // allow typed values
  keepSearchOnSelect = false, // when true, keeps input text even after selecting (and keeps menu open)
  value: propValue,
  errorText,
  ...rest
}) {
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState(propValue ?? null);

  console.log(inputValue, value);

  useEffect(() => {
    setValue(propValue ?? null);
  }, [propValue]);

  return (
    <FormControl fullWidth>
      <Autocomplete
        freeSolo={freeSolo}
        options={data}
        getOptionLabel={(option) => getLabel(option)}
        isOptionEqualToValue={(option, val) =>
          getLabel(option) === getLabel(val)
        }
        value={value}
        onChange={(event, newValue, reason) => {
          setValue(newValue);
          // if not keeping search, set input to selected label
          if (!keepSearchOnSelect) {
            setInputValue(getLabel(newValue));
          }
          // callback to parent
          getValue && getValue(event, newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          setInputValue(newInputValue);
          // forward to parent if provided
          externalOnInputChange && externalOnInputChange(newInputValue);
        }}
        renderOption={(propsOption, option) => (
          <StyledMenuItem {...propsOption} key={getLabel(option)}>
            {getLabel(option)}
          </StyledMenuItem>
        )}
        noOptionsText="No results found"
        disableCloseOnSelect={keepSearchOnSelect}
        openOnFocus
        renderInput={(params) => (
          <WrapperTextField
            {...params}
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            placeholder={placeholder}
            errorText={errorText}
            {...rest}
          />
        )}
      />

      {errorText && <WrapperErrorDiv>{errorText}</WrapperErrorDiv>}
    </FormControl>
  );
}

SelectSearchInput.defaultProps = {
  height: 50,
  inputPadding: '14px',
  freeSolo: true,
  keepSearchOnSelect: false,
};

export default SelectSearchInput;
